import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { OTP } from '@symphony-solo/shared/utils/src';
import { CompanyGroupFacade } from '@symphony-solo/domain/company-group/src';

@Injectable()
export class CompanyTokenNotExistGuard implements CanActivate {
  constructor(private companyGroupFacade: CompanyGroupFacade, private navController: NavController) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.companyGroupFacade.getCompanyToken().pipe(
      tap(auth => {
        if(!auth) {
          if (route?.queryParams?.tta) {
            this.navController.navigateForward(`${OTP}?tta=${route?.queryParams?.tta}`);
          }else {
            this.navController.navigateForward(OTP);
          }
        }
      }),
      map((authToken) => {
          return !!authToken;
      })
    );
  }
}
